// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */
import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model';

// Update Workshop Note
export interface UpdateWorkshopNoteRequestPayload {
  id: number;
  noteId: string;
  message: string;
}

export interface UpdateWorkshopNoteSuccessPayload {
  id: number;
  notes: Note[];
}

export interface UpdateWorkshopNoteFailPayload {
  error: Error;
}

export const updateWorkshopNoteActions = createAsyncAction(
  'elearning/UPDATE_WORKSHOP_NOTE_REQUEST',
  'elearning/UPDATE_WORKSHOP_NOTE_SUCCESS',
  'elearning/UPDATE_WORKSHOP_NOTE_FAIL'
)<UpdateWorkshopNoteRequestPayload, UpdateWorkshopNoteSuccessPayload, UpdateWorkshopNoteFailPayload>();
